var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgVodHeartFull = function SvgVodHeartFull(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "13px",
    viewBox: "0 0 15 13",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "57901B18-16B7-435F-825D-A819AE80B269")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "usuwanie-z-ulubionych",
    transform: "translate(-308.000000, -618.000000)",
    fill: "#12100B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "button_Secondary",
    transform: "translate(280.000000, 604.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(28.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "button_icon",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6625971,2.30247163 C12.8024972,1.4660514 11.6537181,1.00537438 10.4328524,1.00537438 C9.35072142,1.00537438 8.32408435,1.36768111 7.50277469,2.03262434 C6.68146504,1.3644553 5.64927858,1 4.56714761,1 C3.3518313,1 2.20310766,1.45960085 1.33740289,2.29440899 C0.477247503,3.13029222 0,4.24301137 0,5.42668653 C0,6.60713587 0.477247503,7.71931748 1.34295228,8.55735197 L6.57602664,13.6274804 C6.82574917,13.8677627 7.15871254,14 7.50832408,14 C7.85238624,14 8.190899,13.8639999 8.43512764,13.6269434 L13.6625971,8.56595216 C14.5227525,7.73060594 15,6.6195005 15,5.43528618 C15,4.24999946 14.5283019,3.13781785 13.6625971,2.30247163 Z",
    id: "ic_favorite"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVodHeartFull, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vod_heart_full.5e070136.svg";
export { ForwardRef as ReactComponent };